/** Copia adaptada de apps/builder-spa/src/api/campaigns.ts. */
import { apiFetch } from './apiClient.js';

export type CampaignStatus = 'draft' | 'scheduled' | 'running' | 'completed' | 'archived';

export interface OutboundCampaign {
  id: string;
  tenantId: string;
  name: string;
  description?: string;
  connectorId: string;
  templateId: string;
  status: CampaignStatus;
  scheduledAt?: string;
  csvObjectKey?: string;
  contactsCount: number;
  deliveredCount: number;
  failedCount: number;
  variableMap?: Record<string, string>;
  rateLimitPerSecond?: number;
  startedAt?: string;
  completedAt?: string;
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

interface ListCampaignsResponse {
  items: OutboundCampaign[];
}

export async function listCampaigns(
  tenantId: string,
  opts: { includeArchived?: boolean; status?: CampaignStatus } = {},
): Promise<OutboundCampaign[]> {
  const params: string[] = [];
  if (opts.includeArchived) params.push('includeArchived=true');
  if (opts.status) params.push(`status=${encodeURIComponent(opts.status)}`);
  const qs = params.length ? `?${params.join('&')}` : '';
  const res = await apiFetch<ListCampaignsResponse | OutboundCampaign[]>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/campaigns${qs}`,
  );
  return Array.isArray(res) ? res : res.items;
}
